import React from 'react';
import AbstractComponent from '../../AbstractComponent';
import Panel from '../../layout/panel/Panel';
import Input from '../../layout/input/Input';
import InputNumber from '../../layout/input/InputNumber';
import InputCheckBox from '../../layout/input/InputCheckBox';
import InputSelectTema from './InputSelectTema';

class Aplicativo extends AbstractComponent { 
    constructor(props) {
        super(props);

        this.state = {
            tema: {}
        }
    }               

    render() {
        return(            
            <div className="col-md-8                                 
                            col-sm-8                                                
                            col-lg-8                                                
                            col-xs-8">
                <Input
                    md={12} 
                    xs={12} 
                    sm={12} 
                    lg={12}
                    id="token_api"
                    nome="token_api"                        
                    value={this.props.form.token_api}                                             
                    erro={this.props.erroForm.token_api}
                    readOnly={true}                        
                >                    
                    Token API
                </Input>

                <Input
                    md={12} 
                    xs={12} 
                    sm={12} 
                    lg={12}
                    id="nome_app"
                    nome="nome_app"
                    value={this.props.form.nome_app}                     
                    defaultFoco={true}
                    erro={this.props.erroForm.nome_app}
                    onChange={(e) => this.props.onChange(e)}
                >                    
                    Nome do Aplicativo
                </Input>
                
                <Input
                    md={12} 
                    xs={12} 
                    sm={12} 
                    lg={12}
                    id="short_cut"
                    nome="short_cut"
                    value={this.props.form.short_cut}                     
                    erro={this.props.erroForm.short_cut}
                    onChange={(e) => this.props.onChange(e)}                   
                >                    
                    Label do Atalho do Aplicativo
                </Input>  

                <InputSelectTema
                    md={12} 
                    xs={12} 
                    sm={12} 
                    lg={12}
                    id="tema"
                    nome="tema"                     
                    temas={this.props.temas}               
                    editarId={this.props.form.tema}
                    value={this.props.form.tema}
                    erro={this.props.erroForm.tema}                                        
                    onChange={(e) => this.props.onChange(e)}
                />

                <Panel 
                    md={12} 
                    xs={12}
                    sm={12} 
                    lg={12}
                    title="Desktop"
                >
                    <InputNumber
                        md={12} 
                        xs={12}
                        sm={12} 
                        lg={12}
                        id="width_logo_empresa_menu_desktop"
                        nome="width_logo_empresa_menu_desktop"
                        value={this.props.form.width_logo_empresa_menu_desktop}                         
                        erro={this.props.erroForm.width_logo_empresa_menu_desktop}
                        disabled={this.props.form.tema === 0}
                        onChange={(e) => this.props.onChange(e)}                    
                    >                    
                        Largura Logo (px)
                    </InputNumber>
                </Panel>

                <Panel 
                    md={12} 
                    xs={12}
                    sm={12} 
                    lg={12}
                    title="Mobile"
                >
                    <InputCheckBox
                        md={12} 
                        xs={12}
                        sm={12} 
                        lg={12}
                        id="display_logo_empresa_menu_mobile"
                        nome="display_logo_empresa_menu_mobile"
                        value={this.props.form.display_logo_empresa_menu_mobile}                         
                        erro={this.props.erroForm.display_logo_empresa_menu_mobile}
                        checked={parseInt(this.props.form.display_logo_empresa_menu_mobile,10) === 1}
                        disabled={this.props.form.tema === 0}
                        onChange={(e) => this.props.onChange(e)}                   
                    >                    
                        Exibir logo
                    </InputCheckBox>

                    <Input
                        md={4} 
                        xs={12}
                        sm={4} 
                        lg={4}
                        id="width_logo_empresa_menu_mobile"
                        nome="width_logo_empresa_menu_mobile"
                        value={this.props.form.width_logo_empresa_menu_mobile}                         
                        erro={this.props.erroForm.width_logo_empresa_menu_mobile}
                        disabled={parseInt(this.props.form.display_logo_empresa_menu_mobile, 10) === 0}
                        onChange={(e) => this.props.onChange(e)}                   
                    >                    
                        Largura Logo (px)
                    </Input>

                    <InputNumber
                        md={4} 
                        xs={12}
                        sm={4} 
                        lg={4}
                        id="ml_empresa_menu_mobile"
                        nome="ml_empresa_menu_mobile"
                        value={this.props.form.ml_empresa_menu_mobile}                         
                        erro={this.props.erroForm.ml_empresa_menu_mobile}
                        disabled={parseInt(this.props.form.display_logo_empresa_menu_mobile, 10) === 0}
                        onChange={(e) => this.props.onChange(e)}                   
                    >                    
                        Margem a esquerda (px)
                    </InputNumber>

                    <InputNumber
                        md={4} 
                        xs={12}
                        sm={4} 
                        lg={4}
                        id="mt_empresa_menu_mobile"
                        nome="mt_empresa_menu_mobile"
                        value={this.props.form.mt_empresa_menu_mobile}                         
                        erro={this.props.erroForm.mt_empresa_menu_mobile}
                        disabled={parseInt(this.props.form.display_logo_empresa_menu_mobile, 10) === 0}
                        onChange={(e) => this.props.onChange(e)}                   
                    >                    
                        Margem ao Topo (px) 
                    </InputNumber> 
                </Panel> 
            </div>            
        )
    }
}

export default Aplicativo;